import { gql } from '@apollo/client'

import { AUTH_DATA_KEY } from '../constants'

export const getPersistedAuthData = () => {
  return JSON.parse(localStorage.getItem(AUTH_DATA_KEY))
}

export const setPersistedAuthData = (authData) => {
  localStorage.setItem(AUTH_DATA_KEY, JSON.stringify(authData))
}

export const deletePersistedAuthData = () => {
  localStorage.removeItem(AUTH_DATA_KEY)
}

export const LOGIN_USER = gql`
  mutation LoginUser($username: String!, $password: String!) {
    login(input: { username: $username, password: $password }) {
      authToken
      refreshToken
      user {
        id
        email
        firstName
        lastName
        points
        location
        completion
        capabilities
        profilePic
      }
    }
  }
`
